import { render, staticRenderFns } from "./AccessTable.vue?vue&type=template&id=2579e39e"
import script from "./AccessTable.vue?vue&type=script&lang=js"
export * from "./AccessTable.vue?vue&type=script&lang=js"
import style0 from "./AccessTable.vue?vue&type=style&index=0&id=2579e39e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports